export const API_URL = 'https://api.socioglamm.com';
export const BASE_URL = 'https://stage.socioglamm.com';
export const TEST_URL = 'https://test.socioglamm.com';
